import React, { useEffect, useState } from 'react';
import dcm from '../../../../assets/images/publish/dcm.png';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { setPreloader } from '../../../../slices/layouts/reducer';
import { setCreativesForPublish, setDcmAdvertiserId, setDcmCampaignId, setDcmCampaigns, setDcmName, setDcmPoliteLoad, setDcmPublishSettings, setDcmPublishType, setPublishLoader } from '../../../../slices/publish/reducer';
import { Card, CardBody, CardHeader, Col, Input, Row, Label } from 'reactstrap';
import { replace } from 'lodash';
import { useLocation } from 'react-router-dom';
import CustomSelect from '../../../../Components/Common/CustomSelect';
import { getDcmCampaigns, getDcmProfiles, publishDcm, refreshDcmAdvertisers, refreshDcmCampaigns } from '../../../../slices/publish/dcm/thunk';
import { toggleSelectDcmProfileModal } from '../../../../slices/modals/reducer';
import CustomSelectWithSearch from '../../../../Components/Common/CustomSelectWithSearch';

const typeOptions = [{ name: 'Animated (HTML5)', value: 'html' }, { name: 'Static', value: 'static' }, { name: 'Both', value: 'both' }];

function DcmSettings() {
  const dispatch = useDispatch();
  const location = useLocation();

  const selectDcmState = createSelector(state => state, state => ({
    selectedCreativesPublish: state.Publish.selectedCreativesPublish,
    versions: state.Campaign.versions,
    currentCampaign: state.Campaign.currentCampaign,
    dcmProfileId: state.Publish.dcmProfileId,
    dcmAdvertisers: state.Publish.dcmAdvertisers,
    dcmAdvertiserId: state.Publish.dcmAdvertiserId,
    dcmCampaigns: state.Publish.dcmCampaigns,
    dcmCampaignId: state.Publish.dcmCampaignId,
    dcmPoliteLoad: state.Publish.dcmPoliteLoad,
    dcmName: state.Publish.dcmName
  }));
  const {
    selectedCreativesPublish,
    versions,
    currentCampaign,
    dcmProfileId,
    dcmAdvertisers,
    dcmAdvertiserId,
    dcmCampaigns,
    dcmCampaignId,
    dcmPoliteLoad,
    dcmName
  } = useSelector(selectDcmState);

  const [advertisers, setAdvertisers] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedAdvertiser, setSelectedAdvertiser] = useState({});
  const [selectedCampaign, setSelectedCampaign] = useState({});

  useEffect(() => {
    if (dcmAdvertisers.length > 0) {
      setAdvertisers(dcmAdvertisers.map(item => {
        return { name: item.name, value: item.id }
      }));
    }
  }, [dcmAdvertisers]);

  useEffect(() => {
    if (dcmAdvertiserId) {
      const foundAdvertiser = dcmAdvertisers.find(item => item.id === dcmAdvertiserId);
      if (foundAdvertiser) {
        setSelectedAdvertiser({ name: foundAdvertiser.name, value: foundAdvertiser.id });
      }
    }
  }, [dcmAdvertiserId]);

  useEffect(() => {
    if (dcmCampaigns.length > 0) {
      setCampaigns(dcmCampaigns.map(item => {
        return { name: item.name, value: item.id }
      }));
    }
  }, [dcmCampaigns]);

  useEffect(() => {
    if (dcmCampaignId) {
      const foundCampaign = dcmCampaigns.find(item => item.id === dcmCampaignId);
      if (foundCampaign) {
        setSelectedCampaign({ name: foundCampaign.name, value: foundCampaign.id });
      }
    }
  }, [dcmCampaignId]);

  async function handleAdvertiserSelect(advertiser) {
    dispatch(setPublishLoader(true));
    dispatch(setDcmAdvertiserId(advertiser.value));
    await dispatch(getDcmCampaigns());
    setSelectedCampaign({});
    dispatch(setDcmCampaignId(null));
    dispatch(setPublishLoader(false));
  }

  function handleCampaignSelect(campaign) {
    dispatch(setDcmCampaignId(campaign.value));
  }

  async function refreshAdvertisers() {
    dispatch(setDcmAdvertiserId(null));
    dispatch(setDcmCampaignId(null));
    dispatch(setDcmCampaigns([]));
    setSelectedAdvertiser({});
    setSelectedCampaign({});
    await dispatch(refreshDcmAdvertisers());
  }

  async function refreshCampaigns() {
    dispatch(setDcmCampaignId(null));
    setSelectedCampaign({});
    await dispatch(refreshDcmCampaigns());
  }

  function handleTypeSelect(type) {
    dispatch(setDcmPublishType(type.value));
  }

  async function handlePublish() {
    dispatch(setPublishLoader(true));
    if (dcmProfileId) {
      await dispatch(publishDcm());
    } else {
      await dispatch(getDcmProfiles());
      dispatch(toggleSelectDcmProfileModal());
    }
    dispatch(setPublishLoader(true));

  }

  function goBack() {
    dispatch(setCreativesForPublish([]));
    dispatch(setDcmPublishSettings(false));
  }
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <div className='w-100 p-3 d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <button className='btn btn-light btn-icon fw-bold' onClick={goBack}>
                  <i className='ri-arrow-left-line'></i>
                </button>
              </div>
              <div className='d-flex align-items-center justify-content-end'>
                <img src={dcm} className='w-auto me-4' style={{ height: '30px' }} draggable='false' />
                {dcmCampaignId ?
                  <button className='btn btn-success' onClick={handlePublish}>
                    Publish
                  </button>
                  : null}
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xxl={8} xl={8} lg={8} md={12} sm={12}>
          <Card>
            <CardHeader>
              Publish Settings
            </CardHeader>
            <CardBody>
              <Row>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12}>
                  <div className='w-100 d-flex flex-column'>
                    <Label className='w-100' htmlFor='name'>Name</Label>
                    <Input type='text' name='name' id='name' className='form-input' onChange={(e) => dispatch(setDcmName(e.target.value))} value={dcmName}/>
                  </div>
                  <div className='w-100 form-check form-check-primary mt-3'>
                    <Input
                      className='form-check-input bg-light border-0'
                      id={'politeLoad'}
                      name={'politeLoad'}
                      type='checkbox'
                      checked={dcmPoliteLoad}
                      onChange={() => dispatch(setDcmPoliteLoad(!dcmPoliteLoad))}
                    />
                    <Label className='fw-normal' for={'politeLoad'}>Use polite load</Label>
                  </div>
                  {/* <div className='mt-2 w-100 d-flex flex-column'>
                    <Label className='w-100' htmlFor='name'>Type</Label>
                    <CustomSelect
                      tag='div'
                      className='form-select'
                      placeholder='Select Type'
                      options={typeOptions}
                      onChange={(type) => handleTypeSelect(type)}
                    />
                  </div> */}
                </Col>
                <Col xxl={6} xl={6} lg={6} md={12} sm={12}>
                  <div className='w-100 d-flex flex-column'>
                    <Label>Advertiser</Label>
                    <div className='w-100 d-flex align-items-center flex-nowrap'>
                      <CustomSelectWithSearch
                        tag='div'
                        className='form-select'
                        placeholder='Select Advertiser'
                        onChange={(advertiser) => handleAdvertiserSelect(advertiser)}
                        options={advertisers}
                        value={(selectedAdvertiser?.name || '')}
                      />
                      <button className='btn btn-soft-info btn-icon ms-2' onClick={refreshAdvertisers}>
                        <i className='mdi mdi-refresh fs-5'></i>
                      </button>
                    </div>
                  </div>
                  <div className='mt-2 w-100 d-flex flex-column'>
                    <Label>Campaign</Label>
                    <div className='w-100 d-flex align-items-center flex-nowrap'>
                      <CustomSelectWithSearch
                        tag='div'
                        className='form-select'
                        placeholder='Select Campaign'
                        onChange={(campaign) => handleCampaignSelect(campaign)}
                        options={campaigns}
                        value={(selectedCampaign?.name || '')}
                      />
                      <button className='btn btn-soft-info btn-icon ms-2' onClick={refreshCampaigns}>
                        <i className='mdi mdi-refresh fs-5'></i>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col xxl={4} xl={4} lg={4} md={12} sm={12}>
          <Card>
            <CardHeader>
              Banners to be published in DoubleClick Dcm
            </CardHeader>
            <CardBody>
              <div className='w-100 d-flex flex-column'>
                {selectedCreativesPublish ? selectedCreativesPublish.map((item, idx) => {
                  const foundVersion = versions.find(version => version._id === item.versionId);
                  return (
                    <div className='w-100 d-flex flex-row align-items-center' key={idx}>
                      {currentCampaign.bannerType === 'html' &&
                        <i className='ri-html5-fill fs-15'></i>
                      }
                      {currentCampaign.bannerType === 'image' &&
                        <i className='bx bxs-image-alt fs-15'></i>
                      }
                      <p className='ms-1 mb-0'>{foundVersion.name} {item.size}</p>
                    </div>
                  )
                }) : null}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default DcmSettings
